<template lang="pug">  
    v-col.pa-0#contacto(v-if='Inicio')
        //-MVOIL
        v-container.d-md-none.containercolorMOVIL
            v-col
                v-row.align-center.justify-center
                    v-col(cols=12 md=6)        
                        v-card-text
                            v-form(autocomplete='false' v-model='validación')
                                v-col(cols=12 md=6)
                                    v-row.justify-center.align-center
                                        h1.font-weight-bold( style=' line-height : 5px; font-size: 33px; color:var(--primary)' ) {{Inicio.contactoayuda}}
                                    v-row.mt-7.justify-center.align-center
                                        h1.font-weight-bold( style=' line-height : 5px; font-size: 25px; color:var(--secondary)' ) {{Inicio.contactoayuda2}}
                                    v-row.mt-7.conversemosmovil.justify-center.align-center
                                    div.d-flex.flex-column.align-center
                                        .lineamorada( style='width:65px' )
                                    v-row.justify-center.align-center
                                    
                                        p.font-weight-bold.mt-2( style=' font-size: 15px; color:var(--secondary)' ) {{Inicio.conversemos}}
                                v-col( cols=12 )
                                    h4.font-weight-bold.text-center( style=' font-size: 15px; color:var(--secondary)' ) {{Inicio.correoElectronico}}
                                        v-row.mt-4
                                            v-col( cols=12 md=7).elevation-0.pa-0
                                                v-text-field(:rules='[Reglas.requerido]' flat background-color='white' v-model='información["Nombre: "]' solo label='Nombre' autocomplete="off").forma_input
                                        v-row
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.email_valido]' background-color='white' v-model='información["Correo electrónico: "]' autocomplete="off" flat solo label='Correo').forma_input
                                        v-row    
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field( background-color='white' solo  flat label='Ciudad' v-model='información["Ciudad: "]' autocomplete="off" ).forma_input
                                        v-row  
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.solo_números]' background-color='white' solo  flat label='Teléfono' v-model='información["Teléfono: "]' autocomplete="off" ).forma_input
                                        v-row  
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.solo_letras]'  hide-details background-color='white' solo flat label='Mensaje'  v-model='información["Mensaje: "]' autocomplete="off" ).forma_input
                                        v-col( cols=12 md=7).mt-12
                                            v-row.justify-center.align-center
                                                v-btn( style='color: var(--secondary)' outlined rounded 
                                                @click='enviar()' :loading='enviando_correo' :disabled='!validación').elevation-0
                                                    span ENVIAR
        v-row.justify-center.align-center.d-md-none
            video( :src='Contenido.video_piepagina' height='100%' width='100%' autoplay muted loop )
        //-PC      
        v-container(fluid).pa-0.d-none.d-md-block.containercolorPC
            v-col.mt-12
                v-row.align-end.justify-end.mt-12
                    v-col(cols=12 md=12).mt-12        
                        v-card-text
                            v-form(autocomplete='false' v-model='validación')
                                v-col.align-center.text-center
                                    v-row
                                        h1.textocontacto.font-weight-bold {{Inicio.contactoayuda}}
                                v-row.mt-3.ml-2
                                    h1.textocontactodos.font-weight-bold {{Inicio.contactoayuda2}}
                                v-row.mt-7.conversemos.ml-0
                                    div.d-flex.flex-column.align-center.mt-0.mr-3
                                        .lineamorada( style='width:65px' )
                                    h2.font-weight-bold {{Inicio.conversemos}}
                            v-col(cols=12)
                                v-row.align-center.text-center
                                    span.Celular.font-weight-bold {{Inicio.celular}}      
                                    v-btn(elevation='0' icon tile ).botonWhatsapp
                                        v-img(:src='Inicio.logowhatsapp' heigth='7px' width='40px' contain)       
                            v-row.align-start.justify-end
                                v-col( cols=12  md=4).direccion.mt-6
                                    v-form(v-model='validación_whatsapp')
                                        v-textarea(:rules='[Reglas.requerido, Reglas.solo_letras]' hide-details  background-color='white' flat solo 
                                        label='Hola Janna, tengo una consulta...' v-model='mensaje').forma_input
                                        v-row.justify-center.align-center.mt-12
                                            v-btn( style='color: var(--secondary)'  outlined rounded 
                                            :disabled='!validación_whatsapp' target='_blank'
                                            :href='`https://wa.me/${celular}?text=${mensaje}`').mt-2.elevation-0
                                                span ENVIAR
                                
                                v-col( cols=12 md=6).direccionform
                                    h3.correoElectronico.ml-2.colorcorreo.font-weight-bold.mb-3 {{Inicio.correoElectronico}} 
                                    v-form(v-model='validación' autocomplete="off")
                                        v-row.elevation-0
                                            v-col( cols=12 md=7).elevation-0.pa-0
                                                v-text-field(:rules='[Reglas.requerido]' flat background-color='white' v-model='información["Nombre: "]'
                                                solo label='Nombre' autocomplete="off").forma_input
                                        v-row
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.email_valido]' background-color='white' 
                                                v-model='información["Correo electrónico: "]' autocomplete="off" flat solo label='Correo').forma_input
                                        v-row    
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field( background-color='white' solo  flat label='Ciudad' 
                                                v-model='información["Ciudad: "]' autocomplete="off" ).forma_input
                                        v-row  
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.solo_números]' background-color='white' solo  flat  
                                                label='Teléfono' v-model='información["Teléfono: "]' autocomplete="off" ).forma_input
                                        v-row  
                                            v-col( cols=12 md=7).pa-0
                                                v-text-field(:rules='[Reglas.requerido, Reglas.solo_letras]'  hide-details background-color='white'  
                                                solo flat label='Mensaje'  v-model='información["Mensaje: "]' autocomplete="off" ).forma_input
                                    
                                    v-col( cols=12 md=7).mt-12
                                        v-row.justify-center.align-center
                                            v-btn( style='color: var(--secondary)' outlined rounded 
                                            @click='enviar()' :loading='enviando_correo' :disabled='!validación').elevation-0
                                                span ENVIAR

           
</template>
  
<style lang="sass" scoped>
    
    .forma_input
        border-radius: 25px 25px 25px 25px !important
    .containercolorPC
        background-color: #F2F2F2
        height: 800px

    .containercolorMOVIL
        background-color: #F2F2F2
        height: 750px

    // header
    //     height: 50
    //     background-color: #F2F2F2
    //     display: flex
    //     flex-direction: column
    //     align-items: center
    //     justify-content: center
        // background-size: cover
    
    .lineamorada
        height: 4px
        background-color: #270640 !important
    
    .textocontacto
    
        position: relative
        bottom: 10px
        left: 32vh
        font-size: 60px
        font-weight: 700
        color: var(--primary)
    .textocontactodos
        position: relative
        bottom: 10px
        left: 32vh
        font-size: 45px
        font-weight: 700
        color: var(--secondary)
    .colorcorreo
        color: var(--secondary)
    .conversemos
        position: relative
        bottom: 15px
        left: 50vh
        font-size: 12px
        
        color: var(--secondary)
    
    .textocontactomovil
    
        position: relative
        bottom: 10px
        font-size: 50px
        font-weight: 700
        color: var(--primary)
    .textocontactodosmovil
        position: relative
        bottom: 10px
        
        font-size: 30px
        font-weight: 700
        color: var(--secondary)
   
    .conversemosmovil
        position: relative
        bottom: 20px
        left: 15vh
        font-size: 10px
        
        color: var(--secondary)

    .Celular
        top: 70px
        position: relative
        
        left: 58vh
        font-size: 15px
        color: var(--secondary)

    .botonWhatsapp
        top: 70px
        position: relative
        
        left: 40vh
        
    .direccion
        position: relative
        bottom: 0
        top: 70px
        left: 0
    .direccionform
        position: relative
        bottom: 150px
        left: 70px
       
     
 
</style>
<script>
    

    import { mapState, mapActions } from 'vuex'
    export default {
    data: ()=>({
      
        validación: true,
        validación_whatsapp: true,
        model: 0,
        enviando_correo: false,
        información: {},
        texto: 'Enviar mensaje',
        mensaje: '',
    }),
    computed: {
        celular(){
            return `${this.Inicio.celular.substring(0, 3) == "+51" ? this.Inicio.celular.split(" ").join("") : '+51'+this.Inicio.celular.split(" ").join("") }`
        },
        ...mapState({
            Reglas: ({Ayudas})=>Ayudas.reglas,
        }),
    },
    methods: {
        ...mapActions({
            enviar_correo_electronico: 'Contacto/enviar_correo_electronico',
            activar_snackbar: 'Ayudas/activar_snackbar',
        }),
        enviar(){
            const titulo = 'Información del contacto'
            const asunto = `Nuevo contacto`
            let cuerpo = `
            <table>`
            Object.keys(this.información).map( i => cuerpo+='<tr><td>' + i + '</td><td>' + this.información[i] + '</td></tr>')
            cuerpo += `</table>`
            const { configuracion_de_correo, correo_electronico} = this.Contacto.configuración_de_correo
            this.enviando_correo = true
            this.enviar_correo_electronico({titulo, cuerpo, asunto, correo_electronico, configuracion_de_correo})
            .then( () => {
                this.activar_snackbar('Se ha enviado su mensaje. Nos pondremos en contacto lo más pronto posible.')
                this.enviando_correo = false
                this.información  = {
                "Forma de contacto": [],
                }
                this.validación = true
            })
            .catch( error=>
                this.activar_snackbar(`Ha ocurrido un error: ${error}. Inténtelo de nuevo más tarde.`)
            )
        },
    },
}
</script>


